import React from "react";

const DEFAULT_AVATAR = "/profile.jpg";

export default function StudentListPanel({
  t,
  activeTab,
  students,
  staff,
  selectedEntity,
  setSelectedEntity,
  onAddStudent,
  onEditStudent,
  onDeleteStudent,
  onAddStaff,
  onEditStaff,
  onDeleteStaff,
  studentImportProps,
  staffImportProps,
}) {
  const {
    importing: studentImporting,
    importResult: studentImportResult,
    exportStudentsToCSV,
    handleImportStudentsCSV,
  } = studentImportProps;

  const {
    importing: staffImporting,
    exportStaffToCSV,
    handleImportStaffCSV,
  } = staffImportProps;

  return (
    <aside className="su-sidebar">
      {activeTab === "students" && (
        <>
          <div className="su-pane-title">{t("Students")}</div>
          <div className="su-controls" style={{ flexDirection: 'row', flexWrap: 'wrap', gap: '8px' }}>
            <button
              className="su-primary"
              onClick={onAddStudent}
              style={{ flex: '1 1 auto', minWidth: '100px' }}
            >
              + {t("Add Student")}
            </button>
            <button
              className="su-secondary"
              onClick={() =>
                document.getElementById("su-csv-import").click()
              }
              title={t("Import students from CSV")}
              style={{ flex: '1 1 auto', minWidth: '80px' }}
            >
              📤 {t("Import")}
            </button>
            <input
              type="file"
              id="su-csv-import"
              accept=".csv"
              onChange={handleImportStudentsCSV}
              hidden
            />
            <button
              className="su-secondary"
              onClick={exportStudentsToCSV}
              title={t("Export all students to CSV")}
              style={{ flex: '1 1 auto', minWidth: '80px' }}
            >
              📥 {t("Export")}
            </button>
          </div>
          <div className="su-list">
            {students.map((s) => (
              <div
                key={s.id}
                className={`su-list-item ${selectedEntity?.type === "student" && selectedEntity?.id === s.id ? "active" : ""}`}
                onClick={() =>
                  setSelectedEntity({ type: "student", id: s.id })
                }
              >
                <div className="su-list-left">
                  <img
                    src={s.avatar || s.profile_picture || DEFAULT_AVATAR}
                    alt=""
                    className="su-avatar"
                  />
                  <div>
                    <div className="su-name">
                      {s.name}
                      {s.voice_recorded === true && (
                        <span
                          title={t("Voice recorded")}
                          style={{ color: "#22c55e", marginLeft: 6 }}
                        >
                          ✓
                        </span>
                      )}
                      {s.voice_recorded === false && s.email && (
                        <span
                          title={t("Voice pending")}
                          style={{ color: "#f59e0b", marginLeft: 6 }}
                        >
                          ⏳
                        </span>
                      )}
                    </div>
                    <div className="su-meta">
                      {s.email
                        ? s.email
                        : `${t("Class")} ${s.class} • ${s.section}`}
                    </div>
                  </div>
                </div>
                <div className="su-list-right">
                  <button
                    className="su-icon"
                    title={t("Edit")}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditStudent(s);
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    className="su-icon danger"
                    title={t("Delete")}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteStudent(s.id);
                    }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))}
            {!students.length && (
              <div className="su-empty">{t("No students yet")}</div>
            )}
          </div>
        </>
      )}

      {activeTab === "staff" && (
        <>
          <div className="su-pane-title">{t("Staff")}</div>
          <div className="su-controls" style={{ flexDirection: 'row', flexWrap: 'wrap', gap: '8px' }}>
            <button
              className="su-primary"
              onClick={onAddStaff}
              style={{ flex: '1 1 auto', minWidth: '100px' }}
            >
              + {t("Add Staff")}
            </button>
            <button
              className="su-secondary"
              onClick={() =>
                document.getElementById("su-staff-csv-import").click()
              }
              title={t("Import staff from CSV")}
              disabled={staffImporting}
              style={{ flex: '1 1 auto', minWidth: '80px' }}
            >
              {staffImporting ? "⏳..." : "📤"} {t("Import")}
            </button>
            <input
              type="file"
              id="su-staff-csv-import"
              accept=".csv"
              onChange={handleImportStaffCSV}
              hidden
            />
            <button
              className="su-secondary"
              onClick={exportStaffToCSV}
              title={t("Export all staff to CSV")}
              style={{ flex: '1 1 auto', minWidth: '80px' }}
            >
              📥 {t("Export")}
            </button>
          </div>
          <div className="su-list">
            {staff.map((st) => (
              <div
                key={st.id}
                className={`su-list-item ${selectedEntity?.type === "staff" && selectedEntity?.id === st.id ? "active" : ""}`}
                onClick={() =>
                  setSelectedEntity({ type: "staff", id: st.id })
                }
              >
                <div className="su-list-left">
                  <img
                    src={
                      st.avatar || st.profile_picture || DEFAULT_AVATAR
                    }
                    alt=""
                    className="su-avatar"
                  />
                  <div>
                    <div className="su-name">{st.name}</div>
                    <div className="su-meta">{st.role}</div>
                  </div>
                </div>
                <div className="su-list-right">
                  <button
                    className="su-icon"
                    title={t("Edit")}
                    onClick={() => {
                      onEditStaff(st);
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    className="su-icon danger"
                    title={t("Delete")}
                    onClick={() => onDeleteStaff(st.id)}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))}
            {!staff.length && (
              <div className="su-empty">{t("No staff yet")}</div>
            )}
          </div>
        </>
      )}
    </aside>
  );
}
